"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.columnsToNumeral = void 0;
function columnsToNumeral(value) {
    if (!value) {
        return value;
    }
    var possibleValues = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
    ];
    var possibleNumerals = [
        'one',
        'two',
        'three',
        'four',
        'five',
        'six',
        'seven',
        'eight',
        'nine',
        'ten',
        'eleven',
        'twelve',
        'thirteen',
        'fourteen',
        'fifteen',
        'sixteen',
    ];
    if (possibleNumerals.includes(value)) {
        return value;
    }
    if (possibleValues.includes(value)) {
        return possibleNumerals[parseInt(value, 10) - 1];
    }
    return false;
}
exports.columnsToNumeral = columnsToNumeral;
//# sourceMappingURL=widths.js.map